import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

const styleObject = css`
  border-bottom: 1px solid ${theme.colors.neutral30};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.spacing(2, 0)};

  :first-of-type {
    border-top: 1px solid ${theme.colors.neutral30};
  }
`;

export const ListFieldItemStyles = {
  listFieldItem: styleObject,
};
